module.exports = __webpack_public_path__ + "static/img/logo_tm.581e6be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_tm.png
// module id = F+WP
// module chunks = 9